var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M93 0H0V93H93V0ZM89 4H4V89H89V4ZM33.5 28V38L21 46L33.5 53.5V64L12 50.5V41.5L33.5 28ZM59 38V28L80.5 41.5V50.5L59 64V53.5L71.5 46L59 38ZM46.5 20H55.5L46.5 72H37.5L46.5 20Z","fill":"white"}));
}

LogoInline.defaultProps = {"width":"93","height":"93","viewBox":"0 0 93 93","fill":"none"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
